/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */

export type GetBuslineSchedulesOrder = typeof GetBuslineSchedulesOrder[keyof typeof GetBuslineSchedulesOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBuslineSchedulesOrder = {
  favorite: 'favorite',
} as const;
